import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EMPTY_FORM = {
    nome: "",
    azienda: "",
    email: "",
    telefono: "",
    messaggio: "",
    privacy: false,
    website: "",
};

export function useContactForm() {
    const [form, setForm] = useState(EMPTY_FORM);
    const [sending, setSending] = useState(false);

    const set = (key) => (e) =>
        setForm((f) => ({
            ...f,
            [key]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
        }));

    const onSubmit = async (e) => {
        e.preventDefault();
        if (sending) return;
        setSending(true);
        try {
            await axios.post(`${API}/contact`, form);
            toast.success("Richiesta inviata con successo. Ti ricontatteremo al più presto.");
            setForm(EMPTY_FORM);
        } catch (err) {
            const detail = err?.response?.data?.detail;
            toast.error(
                typeof detail === "string"
                    ? detail
                    : "Errore nell'invio. Riprova o contattaci telefonicamente.",
            );
        } finally {
            setSending(false);
        }
    };

    return { form, sending, set, onSubmit };
}
